module.exports = __webpack_public_path__ + "circleci-logo-18b250974e45d9c8b1fc72d584ba0b3b.svg";